import _ from "lodash";
import PGSHelper from "../../helpers/PGSHelper.js";
const pgsHelper = new PGSHelper();

export default class TicketPromedioProducto {
  static getDocData({ TITLE, FI, FF, FG, HG, data }) {
    const tableBody = this.getTable(data);

    const content = [];

    // content.push({
    //   text: TITLE,
    //   bold: true,
    //   fontSize: 16,
    //   alignment: "center",
    //   margin: [0, 0, 0, 10],
    // });

    content.push({
      columns: [
        {
          width: "50%",
          text: [{ text: "FECHA: ", bold: true }, FI + (FF ? ` - ${FF}` : "")],
          fontSize: 12,
        },
        {
          width: "50%",
          text: [
            { text: "Generado: ", bold: true },
            FG + "  ",
            { text: "Hora: ", bold: true },
            HG,
          ],
          alignment: "right",
          fontSize: 12,
        },
      ],
      columnGap: 10,
      margin: [0, 0, 0, 10],
    });

    content.push({
      table: {
        headerRows: 1,
        widths: [
          "*",
          "auto",
          "auto",
          "auto",
          "auto",
          "auto",
          "auto",
          "auto",
          "auto",
          "auto",
        ],
        body: tableBody,
      },
      layout: {
        fillColor: (rowIndex, node) => {
          // pintar fila de encabezado general
          if (rowIndex === 0) return "#EEEEEE";
          // pintar fila de categoría
          if (node.table.body[rowIndex][0].colSpan === 10) {
            return "#DDDDDD";
          }
          return null;
        },
      },
    });

    return {
      pageMargins: [20, 20, 20, 20],
      pageOrientation: "landscape",
      content,
    };
  }

  static getTable(data = []) {
    const header = [
      { text: "Nombre", bold: true },
      { text: "Familia", bold: true },
      { text: "Categoría", bold: true },
      { text: "Vendidos", bold: true },
      { text: "Total por producto", bold: true },
      { text: "Total ventas", bold: true },
      { text: "Cuentas", bold: true },
      { text: "Total comensales", bold: true },
      { text: "Promedio Ticket", bold: true },
      { text: "Promedio x Comensal", bold: true },
    ];

    // agrupar
    const grouped = _.groupBy(
      data,
      (prod) => prod.CategoriaName || "Sin categoría"
    );

    // construir filas: primero titulo, luego productos
    const rows = Object.keys(grouped).flatMap((catName) => {
      const items = grouped[catName];
      const catRow = [
        {
          text: catName,
          colSpan: 10,
          bold: true,
          margin: [0, 4, 0, 4],
        },
        {},
        {},
        {},
        {},
        {},
        {},
        {},
        {},
        {},
      ];
      const prodRows = items.map((prod) => {
        const nombre =
          prod.OriginalId === "Reserva" ? "TEE TIMES" : prod.Nombre || "-";
        return [
          { text: nombre, fontSize: 10 },
          { text: prod.FamiliaName || "-", fontSize: 10 },
          { text: prod.CategoriaName || "-", fontSize: 10 },
          {
            text: pgsHelper.formatNumber(prod.Vendidos || 0),
            fontSize: 10,
            alignment: "right",
          },
          {
            text: `$ ${pgsHelper.formatNumber(prod.Total || 0)}`,
            fontSize: 10,
            alignment: "right",
          },
          {
            text: `$ ${pgsHelper.formatNumber(prod.sumSaleTotals || 0)}`,
            fontSize: 10,
            alignment: "right",
          },
          {
            text: String(prod.countSales || 0),
            fontSize: 10,
            alignment: "right",
          },
          {
            text: String(prod.totalComensales || 0),
            fontSize: 10,
            alignment: "right",
          },
          {
            text: `$ ${pgsHelper.formatNumber(prod.averageTicket || 0)}`,
            fontSize: 10,
            alignment: "right",
          },
          {
            text: `$ ${pgsHelper.formatNumber(prod.averagePerComensal || 0)}`,
            fontSize: 10,
            alignment: "right",
          },
        ];
      });
      return [catRow, ...prodRows];
    });

    return [header, ...rows];
  }
}
